import axios from './axios.interceptors';
import {FlightBody} from "../types/service-types/FlightTypes";

const serializeQueryParams = (params: Record<string, any>) => {
    const searchParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value == null || value === "") return;

        if (Array.isArray(value)) {
            value
                .filter((item) => item != null && item !== "")
                .forEach((item) => searchParams.append(key, String(item)));
            return;
        }

        searchParams.append(key, String(value));
    });

    return searchParams.toString();
};

class SelectedFlightServices {
    public getSelectedFlight = async (body: any): Promise<FlightBody> => {
        try {
            const response = await axios.get('api/v1/flights', {params: body});
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    public previewPrice = async (body: any): Promise<any> => {
        try {
            const response = await axios.get('/api/v1/reservations/previewPrice', {
                params: body,
                paramsSerializer: serializeQueryParams,
            });
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
}

export default new SelectedFlightServices();
